import { render } from "./CardTitleComponent.vue?vue&type=template&id=0cadbc8d&ts=true"
import script from "./CardTitleComponent.vue?vue&type=script&lang=ts"
export * from "./CardTitleComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__